import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import LandingPage from "./pages/LandingPage";
import LoginPage from "./pages/LoginPage";
import AnalizarPaciente from "./pages/AnalizarPaciente";
import AnalisisRadiograph from "./pages/AnalisisRadiograph";
import PreConfirmation from "./pages/PreConfirmation";
import Await from "./pages/Await";
import PostConfirmation from "./pages/PostConfirmation";
import { AuthProvider } from "./contexts/authContext";
import PrivateRoute from "./contexts/routeContext/PrivateRoute";
import ActiveUserGuard from "./contexts/routeContext/ActiveUserGuard";
import { ImageProvider } from "./contexts/imageContext/imageContext";
import Dashboard from "./pages/Dashboard";
import FormGuard from "./contexts/routeContext/FormGuard";
import AnalisisEcograph from "./pages/AnalisisEcograph";
import SideBar from "./components/SideBar";
import AdminMainPage from "./pages/admin/MainPage";
import Subscriptions from "./pages/admin/Subscriptions";
import Reports from "./pages/admin/Reports";
import Users from "./pages/admin/Users";
import Veterinaries from "./pages/admin/Veterinaries";
import EditMyReport from "./pages/EditMyReport";
import NotFound from "./pages/NotFound";

const MainLayout = ({ children }) => (
    <>
        <Navbar />
        {children}
        <Footer />
    </>
);

function App() {
    return (
        <AuthProvider>
            <ImageProvider>
                <Router>
                    <Routes>
                        {/* Admin routes with SideBar but no Navbar/Footer */}
                        <Route
                            path="/admin"
                            element={
                                <PrivateRoute>
                                    <SideBar>
                                        <AdminMainPage />
                                    </SideBar>
                                </PrivateRoute>
                            }
                        />
                        <Route
                            path="/admin/reportes"
                            element={
                                <PrivateRoute>
                                    <SideBar>
                                        <Reports />
                                    </SideBar>
                                </PrivateRoute>
                            }
                        />
                        <Route
                            path="/admin/suscripciones"
                            element={
                                <PrivateRoute>
                                    <SideBar>
                                        <Subscriptions />
                                    </SideBar>
                                </PrivateRoute>
                            }
                        />
                        <Route
                            path="/admin/usuarios"
                            element={
                                <PrivateRoute>
                                    <SideBar>
                                        <Users />
                                    </SideBar>
                                </PrivateRoute>
                            }
                        />
                        <Route
                            path="/admin/veterinarias"
                            element={
                                <PrivateRoute>
                                    <SideBar>
                                        <Veterinaries />
                                    </SideBar>
                                </PrivateRoute>
                            }
                        />
                        {/* Regular routes with Navbar and Footer */}
                        <Route
                            path="/"
                            element={
                                <MainLayout>
                                    <LandingPage />
                                </MainLayout>
                            }
                        />
                        <Route
                            path="/login"
                            element={
                                <MainLayout>
                                    <LoginPage />
                                </MainLayout>
                            }
                        />
                        <Route
                            path="/dashboard"
                            element={
                                <MainLayout>
                                    <PrivateRoute>
                                        <ActiveUserGuard>
                                            <Dashboard />
                                        </ActiveUserGuard>
                                    </PrivateRoute>
                                </MainLayout>
                            }
                        />
                        <Route
                            path="/editmyreport"
                            element={
                                <MainLayout>
                                    <PrivateRoute>
                                        <ActiveUserGuard>
                                            <EditMyReport />
                                        </ActiveUserGuard>
                                    </PrivateRoute>
                                </MainLayout>
                            }
                        />
                        <Route
                            path="/analizar"
                            element={
                                <MainLayout>
                                    <PrivateRoute>
                                        <ActiveUserGuard>
                                            <AnalizarPaciente />
                                        </ActiveUserGuard>
                                    </PrivateRoute>
                                </MainLayout>
                            }
                        />
                        <Route
                            path="/radiografia"
                            element={
                                <MainLayout>
                                    <FormGuard>
                                        <ActiveUserGuard>
                                            <AnalisisRadiograph />
                                        </ActiveUserGuard>
                                    </FormGuard>
                                </MainLayout>
                            }
                        />
                        <Route
                            path="/ecografia"
                            element={
                                <MainLayout>
                                    <FormGuard>
                                        <ActiveUserGuard>
                                            <AnalisisEcograph />
                                        </ActiveUserGuard>
                                    </FormGuard>
                                </MainLayout>
                            }
                        />
                        <Route
                            path="/preconfirmacion"
                            element={
                                <MainLayout>
                                    <PrivateRoute>
                                        <PreConfirmation />
                                    </PrivateRoute>
                                </MainLayout>
                            }
                        />

                        <Route
                            path="/espera"
                            element={
                                <MainLayout>
                                    <PrivateRoute>
                                        <Await />
                                    </PrivateRoute>
                                </MainLayout>
                            }
                        />

                        <Route
                            path="/postconfirmacion"
                            element={
                                <MainLayout>
                                    <PrivateRoute>
                                        <PostConfirmation />
                                    </PrivateRoute>
                                </MainLayout>
                            }
                        />
                        <Route
                            path="/*"
                            element={
                                <MainLayout>
                                    <NotFound />
                                </MainLayout>
                            }
                        />
                    </Routes>
                </Router>
            </ImageProvider>
        </AuthProvider>
    );
}

export default App;
